import script from "./links-component.vue?vue&type=script&setup=true&lang=js"
export * from "./links-component.vue?vue&type=script&setup=true&lang=js"

import "./links-component.vue?vue&type=style&index=0&id=d78a07f0&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d78a07f0"]])

export default __exports__